// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.home-background {
    display: flex;
    height: 100vh;
    background-image: url();
    background-size: cover;
    background-position: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
}

.greetings {
    font-size: 4rem;
    color: rgba(232, 77, 25, 0.86);
    margin-top: 13vh;
    font-weight: bold;
}

.intro-card {
    position: absolute;
    top: 13vh;  
    left: 50%;  
    transform: translateX(-50%);
    padding: 10px;
    width: 30%;
    min-width: 375px; 
    text-align: center; 
    border-radius: 10px; 
}

.home-image {
    position: absolute;
    top: 60vh;
    left: 50%; 
    transform: translateX(-50%);
    max-width: 70vw; 
    max-height: 20vh;
    min-width: 375px;
    min-height: 100px;
}

.resume-background {
    height: 100vh;
    background-image: url();
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.resume-container {
    text-align: center;
    padding: 20px;
    width: 80%; 
    max-width: 800px; 
    min-width: 300px;
    margin: auto; 
    overflow: hidden; 
    height: 80vh; 
}

.resume-embed {
    width: 100%;
    height: 100%; 
}

@media (max-width: 768px) {
    .resume-container {
        width: 95%; 
        padding: 10px; 
    }
    .resume-embed {
        height: auto;
        min-height: 400px; 
    }
}

.backup-instructions {
    color: whitesmoke;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,aAAa;IACjB;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB","sourcesContent":["\n.home-background {\n    display: flex;\n    height: 100vh;\n    background-image: url();\n    background-size: cover;\n    background-position: center;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.greetings {\n    font-size: 4rem;\n    color: rgba(232, 77, 25, 0.86);\n    margin-top: 13vh;\n    font-weight: bold;\n}\n\n.intro-card {\n    position: absolute;\n    top: 13vh;  \n    left: 50%;  \n    transform: translateX(-50%);\n    padding: 10px;\n    width: 30%;\n    min-width: 375px; \n    text-align: center; \n    border-radius: 10px; \n}\n\n.home-image {\n    position: absolute;\n    top: 60vh;\n    left: 50%; \n    transform: translateX(-50%);\n    max-width: 70vw; \n    max-height: 20vh;\n    min-width: 375px;\n    min-height: 100px;\n}\n\n.resume-background {\n    height: 100vh;\n    background-image: url();\n    background-size: cover;\n    background-position: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.resume-container {\n    text-align: center;\n    padding: 20px;\n    width: 80%; \n    max-width: 800px; \n    min-width: 300px;\n    margin: auto; \n    overflow: hidden; \n    height: 80vh; \n}\n\n.resume-embed {\n    width: 100%;\n    height: 100%; \n}\n\n@media (max-width: 768px) {\n    .resume-container {\n        width: 95%; \n        padding: 10px; \n    }\n    .resume-embed {\n        height: auto;\n        min-height: 400px; \n    }\n}\n\n.backup-instructions {\n    color: whitesmoke;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
